import React, { useRef } from 'react';
import IconButton from '@material-ui/core/IconButton';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import CopyToClipboard from 'react-copy-to-clipboard';
import { createStyles, WithStyles, Theme, withStyles } from '@material-ui/core/styles';

const styles = ({
  custom: {
    palette: { colorSupportPowder },
  },
  spacing: { unit },
}: Theme) =>
  createStyles({
    container: {
      display: 'flex',
      border: `1px solid ${colorSupportPowder}`,
      alignItems: 'center',
      padding: `${unit * 2}px ${unit * 3}px`,
    },
    answers: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      rowGap: `${unit * 2}px`,

      '& > div': {
        display: 'flex',
        alignItems: 'center',
        columnGap: `${unit / 2}px`,
      },
    },
    copyButton: {
      height: 'fit-content',
    },
  });

interface InsuranceAnswersCopyProps extends WithStyles<typeof styles> {
  textToCopy: string;
}

const InsuranceAnswersCopy: React.FC<InsuranceAnswersCopyProps> = ({ children, textToCopy, classes }) => {
  const ref = useRef(null);

  const handleSelection = () => {
    if (ref) {
      getSelection()?.selectAllChildren(ref.current!);
    }
  };

  return (
    <div ref={ref} className={classes.container}>
      <div id="insuranceAnswers" className={classes.answers}>
        {children}
      </div>
      <IconButton
        data-lh-id="patient-form-insurance-answers-copy-button"
        onClick={handleSelection}
        className={classes.copyButton}
      >
        <CopyToClipboard text={textToCopy}>
          <FileCopyIcon color="primary" fontSize="small" />
        </CopyToClipboard>
      </IconButton>
    </div>
  );
};

export default withStyles(styles)(InsuranceAnswersCopy);
